import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addCourse } from '@/reducers/courses'
import { AppDispatch, AppState, ICourse } from '@/types'
import { SearchList, SearchListComponentOption } from '@sonans/components'
import dataLayer from '@/utils/dataLayer'

const isExcludedCourse = (course: ICourse) => {
    const excludedNames = ['Biologi 3', 'Fysikk 3']
    return !excludedNames.includes(course.name)
}

export function CourseSearch() {
    const [searchTerm, setSearchTerm] = useState('')
    const [selectedValues, setSelectedValues] = useState<SearchListComponentOption[]>([])

    const dispatch = useDispatch<AppDispatch>()

    const additionalCourses = useSelector(
        (state: AppState) => state.courses.additionalCourses
    )

    const filteredOptions: SearchListComponentOption[] = additionalCourses
        .filter(isExcludedCourse)
        .filter(
            (course) =>
                course.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                course.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
                course.replacedCourses.some((rc) =>
                    rc.name.toLowerCase().includes(searchTerm.toLowerCase())
                ) ||
                course.replacedCourses.some((rc) =>
                    rc.code.toLowerCase().includes(searchTerm.toLowerCase())
                )
        )
        .map((course) => ({ label: course.name, value: String(course.id) }))

    const handleChange = (newValues: SearchListComponentOption[]) => {
        const added = newValues.find(
            (nv) => !selectedValues.find((sv) => sv.value === nv.value)
        )
        if (added) {
            const course = additionalCourses.find((c) => String(c.id) === added.value)
            if (course) {
                dataLayer.push({
                    event: 'karakterkalkulator_karakterer_soketekst',
                    searchterm: searchTerm,
                })
                dispatch(addCourse(course))
            }
        }
        setSelectedValues([])
        setSearchTerm('')
    }

    return (
        <SearchList
            id="course-search"
            label=""
            placeholder="Matematikk R1 eller REA3056"
            options={filteredOptions}
            values={selectedValues}
            onChange={handleChange}
            onChangeSearchTerm={(e) => setSearchTerm(e.target.value)}
            scroll
        />
    )
}
